import { render, staticRenderFns } from "./DisplayPixOrderPayloadModalSection.vue?vue&type=template&id=e356558e&scoped=true"
import script from "./DisplayPixOrderPayloadModalSection.vue?vue&type=script&lang=js"
export * from "./DisplayPixOrderPayloadModalSection.vue?vue&type=script&lang=js"
import style0 from "./DisplayPixOrderPayloadModalSection.vue?vue&type=style&index=0&id=e356558e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e356558e",
  null
  
)

export default component.exports